import { ApiResponse } from 'apisauce';

import { generateApiClient, generateAuthApiClient } from '../api';
import { getGeneralApiProblem } from '../api/api-problem';

const api = generateApiClient();
const authApi = generateAuthApiClient();

export const login = async (credentails: any): Promise<any> => {
  try {
    // make the api call
    const response: ApiResponse<any> = await authApi.post('authentications', credentails);
    // the typical ways to die when calling an api
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      // Toast.show(problem?.message);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const registerUserApi = async (userData: any): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.post('registrations', userData);
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};

export const getMeApi = async (): Promise<any> => {
  try {
    const response: ApiResponse<any> = await api.get('me');
    if (!response.ok) {
      const problem: any = getGeneralApiProblem(response);
      if (problem) return problem;
    }
    const data = response.data;

    return { kind: 'ok', data };
  } catch (e) {
    return { kind: 'bad-data' };
  }
};
